import { useClientContext } from "@hooks/index";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { getDelayManagement } from "./index";

export const useGetDelayManagement = (
  filters: Sentinel.DelayManagement.Filters
) => {
  const customFetch = useClientContext();
  const queryKey = useMemo(() => ["delay-management", filters], [filters]);

  return useQuery({
    queryKey,
    queryFn: () => getDelayManagement(customFetch)(filters),
    retry: false,
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
  });
};
